import React, { useState, useEffect } from 'react';
import store, { borrowerActions } from '@apply/adminStore';
import { BorrowerApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { RefreshEvents } from '../../../common/SharedEvents';
import { formatPhone, handleAdminError } from '../../../common/SharedFunctions';
import { onActionsCellRender } from '../BorrowerFunctions';
import { LinkType } from '../BorrowerConstants';
import LoadPanel from 'devextreme-react/load-panel';

export const EntityPrincipalLinks = ({ parentId, entityId }) => {
    const { dispatch } = store;
    const borrowerApi = new BorrowerApi.BorrowerApi(applicationInsights);

    const [links, set_links] = useState([]);
    const [loadingMessage, set_loadingMessage] = useState('');

    const styles = {
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        buttonContainer2: {
            textAlign: 'right',
            padding: '5px',
        },
        sectionHeader: { margin: '10px 0' },
        formColumn: { paddingBottom: '5px', paddingRight: '5px' },
    };

    useEffect(() => {
        if (!entityId) {
            set_links([]);
            return;
        }

        const refreshEvents = new RefreshEvents();
        refreshEvents.addRefreshListener(function () {
            refreshLinks(entityId);
        });

        loadLinks(entityId);

        return () => {
            refreshEvents.removeRefreshListener(refreshLinks);
        };
    }, [entityId]);

    const refreshLinks = async (entityId) => {
        await loadLinks(entityId);
    };

    const onPercentCellRender = (e) => {
        if (!e.value) {
            return null;
        }
        return e.value.toFixed(2) + '%';
    };

    const onAddLink = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(
            borrowerActions.setEditBorrowerEntityToPrincipalLinkModal({
                editBorrowerEntityToPrincipalLinkModal: {
                    isOpen: true,
                    entityId,
                    principalId: 0,
                    mode: LinkType.Principal,
                },
            })
        );
    };

    const loadLinks = async (id) => {
        if (!id) {
            set_links([]);
            return;
        }

        try {
            set_loadingMessage('Loading...');
            const response = await borrowerApi.getEntityPrincipalLinks(id);
            if (response.statusCode !== 200) {
                throw new Error('Failed to load Entity-Principal links');
            }
            set_links(response.result);
        } catch (ex) {
            set_links([]);
            handleAdminError(ex, 'Failed to load Entity-Principal links. Please try again.');
        } finally {
            set_loadingMessage('');
        }
    };

    const onPhoneRender = (e) => {
        if (!e.value) {
            return null;
        }
        return formatPhone(e.value);
    };

    const onCellDblClick = (e) => {
        dispatch(
            borrowerActions.setEditBorrowerEntityToPrincipalLinkModal({
                editBorrowerEntityToPrincipalLinkModal: {
                    isOpen: true,
                    entityId,
                    principalId: e.data.principalId,
                    mode: LinkType.Principal,
                },
            })
        );
    };

    const onBooleanRender = (e) => {
        return e.value ? 'Yes' : 'No';
    };

    if (!entityId) {
        return null;
    }

    return (
        <div>
            <div className='row'>
                <div
                    className='columns small-12 large-12'
                    style={styles.formColumn}
                >
                    <div style={styles.buttonContainer2}>
                        <button
                            type='button'
                            className='button hollow'
                            onClick={onAddLink}
                            title='Add a new Rep. to this Entity'
                            style={{ marginBottom: '2px' }}
                            disabled={entityId === 0}
                        >
                            Link Principal
                        </button>
                    </div>

                    <DataGrid
                        dataSource={links}
                        showBorders={true}
                        showRowLines={false}
                        rowAlternationEnabled={true}
                        remoteOperations={false}
                        allowColumnReordering={false}
                        allowColumnResizing={true}
                        cellHintEnabled={true}
                        onCellDblClick={onCellDblClick}
                        keyExpr='principalId'
                    >
                        <Column
                            dataField='name'
                            caption='Contact Name'
                        />
                        {/* <Column dataField="city" caption="City" width={120} />
            <Column dataField="state" caption="State" width={70} /> */}
                        <Column
                            dataField='email'
                            caption='Email'
                            width={200}
                        />
                        <Column
                            dataField='phone'
                            caption='Phone'
                            width={110}
                            cellRender={onPhoneRender}
                        />
                        <Column
                            dataField='title'
                            caption='Title'
                            width={150}
                        />
                        <Column
                            dataField='isOfficer'
                            caption='Officer'
                            width={100}
                            cellRender={onBooleanRender}
                        />
                        <Column
                            dataField='percentOwnership'
                            caption='% Owned'
                            width={80}
                            cellRender={onPercentCellRender}
                            alignment='left'
                        />

                        <Column
                            type='actions'
                            alignment='center'
                            cellRender={(e) => onActionsCellRender(e, parentId)}
                            width={50}
                            allowReordering={false}
                            allowSorting={false}
                            allowResizing={false}
                            fixed={true}
                            fixedPosition={'right'}
                        />
                    </DataGrid>
                </div>
            </div>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={!!loadingMessage}
                message={loadingMessage}
            />
        </div>
    );
};
